// Shared constants for the GHL marketplace-install flow. Lives here
// (and not on the page file) so the auth hook can import it without
// pulling the page bundle into the hook's import graph.

// Namespaced to avoid collisions on the same eTLD+1 with unrelated apps.
export const GHL_PENDING_INSTALL_CODE_KEY = 'aspe_ghl_marketplace_pending_code';
